import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import List from './components/List';
import ListDraggableItem from './components/ListDraggableItem';
import PlaceholderDroppableArea from './components/PlaceholderDroppableArea';

const DragAndDropList = ({
  listId,
  items,
  renderItemLabel,
  placeholder,
  onEdit,
  onDelete,
  disableDelete,
  hideEdit,
  hideDelete,
  editTooltipText,
  deleteTooltipText,
  isMobile,
}) => (
  <Droppable droppableId={listId} direction="vertical" isCombineEnabled={false}>
    {(provided, _) => (
      <List provided={provided} innerRef={provided.innerRef}>
        {items.map((item, index) => (
          <Draggable
            draggableId={`draggable-${listId}-${index}`}
            index={index}
            key={`key-${listId}-${index}`}
          >
            {(provided, snapshot) => (
              <ListDraggableItem
                provided={provided}
                snapshot={snapshot}
                innerRef={provided.innerRef}
                label={renderItemLabel(item)}
                disableDelete={disableDelete}
                onEditClick={() => onEdit(index, item)}
                onDeleteClick={() => onDelete(index, item)}
                editTooltipText={editTooltipText}
                deleteTooltipText={deleteTooltipText}
                hideEdit={hideEdit}
                hideDelete={hideDelete}
                isMobile={isMobile}
              />
            )}
          </Draggable>
        ))}
        {provided.placeholder}
        {placeholder && <PlaceholderDroppableArea label={placeholder} />}
      </List>
    )}
  </Droppable>
);

DragAndDropList.propTypes = {
  listId: PropTypes.string.isRequired,
  items: PropTypes.array,
  placeholder: PropTypes.string,
  hideEdit: PropTypes.bool,
  hideDelete: PropTypes.bool,
  editTooltipText: PropTypes.string,
  deleteTooltipText: PropTypes.string,
  isMobile: PropTypes.bool,
};

DragAndDropList.defaultProps = {
  items: [],
  onEdit: () => {},
  onDelete: () => {},
  hideEdit: false,
  hideDelete: false,
  editTooltipText: '',
  deleteTooltipText: '',
  isMobile: false,
};

export { DragAndDropList, DragDropContext };
